// import { faFacebook, faInstagram, faWhatsapp } from "@fortawesome/free-brands-svg-icons";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import React from "react";
// import { motion } from "framer-motion";
// import { useLanguage } from "../../../../contexts/LanguageContext";
// import { Link } from "react-router-dom";
// import { contactUs } from "../../../../utils/translations";
// import "./contact.css";

// export default function ContactUs() {
//   const { language } = useLanguage();

//   return (
//     <>
//       <div style={{ display: "flex", justifyContent: "center", marginTop: "50px" }}>
//         <hr style={{ width: "50%", borderTop: "1px solid var(--secondary-color)" }} />
//       </div>

//       <motion.div
//         className= {`contactUs-section ${language === "ar" ? "arab" : ""} ${language === "ar" ? "rtl" : ""}`}
//         initial={{ opacity: 0, y: 100 }}
//         whileInView={{ opacity: 1, y: 0 }}
//         viewport={{ once: true, amount: 0.1 }}
//         transition={{ duration: 0.5 }}
//       >
//         <div className="contactUs-divider"></div>
//         <div className="contactUs-container">
//           <div className="contactUs-divTitle">
//           <h2 className="contactUs-title">{contactUs[language].contactUs}</h2>
//           </div>
//           <div className="contactUs-content">
//             <div className="contactUs-info">
//               <h3>{contactUs[language].contactInfo}</h3>
//               <p className="contactUs-paragraph">
//                 <b>{contactUs[language].email}:</b> info@Laftah-sy.com
//               </p>
//               <p className="contactUs-paragraph">
//                 <b>{contactUs[language].phone}:</b> +963 999 999 999
//               </p>
//               <p className="contactUs-paragraph">
//                 <b>{contactUs[language].workingHours}:</b> 9:00 AM - 6:00 PM
//               </p>
//               <p className="contactUs-paragraph">
//                 <b>{contactUs[language].address}:</b> 1234 Main Street, Damascus, Syria
//               </p>
//             </div>

//             <div className="contactUs-form">
//               <h3>{contactUs[language].yourMessage}</h3>
//               <form>
//                 <div className="contactUs-formGroup">
//                   <label htmlFor="name">{contactUs[language].name}</label>
//                   <input id="name" type="text" placeholder={contactUs[language].enterName} required />
//                 </div>
//                 <div className="contactUs-formGroup">
//                   <label htmlFor="email">{contactUs[language].email}</label>
//                   <input id="email" type="email" placeholder={contactUs[language].enterEmail} required />
//                 </div>
//                 <div className="contactUs-formGroup">
//                   <label htmlFor="message">{contactUs[language].message}</label>
//                   <textarea id="message" rows="5" placeholder={contactUs[language].writeMessage} required></textarea>
//                 </div>
//                 <button type="submit" className="contactUs-sendButton">{contactUs[language].sendMessage}</button>
//               </form>
//             </div>
//           </div>

//           <div className="contactUs-footer">
//             <p>{contactUs[language].followLaftah}:</p>
//             <div className="contactUs-socialIcons">
//               <FontAwesomeIcon icon={faFacebook} />
//               <FontAwesomeIcon icon={faInstagram} />
//               <FontAwesomeIcon icon={faWhatsapp} />
//             </div>
//             <p>
//               Copyright © 2025 Smart Software Services. All Rights Reserved | {" "}
//               <Link to="/terms">{contactUs[language].terms}</Link> | {" "}
//               <Link to="/privacy">{contactUs[language].privacyPolicy}</Link>
//             </p>
//           </div>
//         </div>
//       </motion.div>
//     </>
//   );
// }

import { faFacebook, faInstagram, faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState } from "react";
import { motion } from "framer-motion";
import { useLanguage } from "../../../../contexts/LanguageContext";
import { Link } from "react-router-dom";
import { contactUs } from "../../../../utils/translations";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./contact.css";

export default function ContactUs() {
  const { language } = useLanguage();
  const [form, setForm] = useState({ name: "", email: "", message: "" });
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.id]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      var response=await axios.post("https://cms.laftah.sss-sy.net/configuration/api/v1/webcontactus/", form,{headers:{'Accept-Language':language}});
      toast.success(response.data.message);
      if(response.status===200||response.status===201){
      setForm({ name: "", email: "", message: "" });
      }else if(response.data.error!=null){
        toast.error(response.data.error);
      }
    } catch (err) {
      console.error(err);
      toast.error(language === "ar" ? "❌ حدث خطأ أثناء الإرسال." : "❌ An error occurred while sending.");
    }

    setLoading(false);
  };

  return (
    <>
      <div style={{ display: "flex", justifyContent: "center", marginTop: "50px" }}>
        <hr style={{ width: "50%", borderTop: "1px solid var(--secondary-color)" }} />
      </div>

      <motion.div
        className={`contactUs-section ${language === "ar" ? "arab" : ""} ${language === "ar" ? "rtl" : ""}`}
        initial={{ opacity: 0, y: 100 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.1 }}
        transition={{ duration: 0.5 }}
      >
        <div className="contactUs-divider"></div>
        <div className="contactUs-container">
          <div className="contactUs-divTitle">
            <h2 className="contactUs-title">{contactUs[language].contactUs}</h2>
          </div>
          <div className="contactUs-content">
            <div className="contactUs-info">
              <h3>{contactUs[language].contactInfo}</h3>
              <p className="contactUs-paragraph">
                <b>{contactUs[language].email}:</b> info@smartsoft-sy.net
              </p>
              <p className="contactUs-paragraph">
                <b>{contactUs[language].phone}:</b> Mob1: 0989882602 | Mob2: 0998764825
              </p>
              <p className="contactUs-paragraph">
                <b>{contactUs[language].workingHours}:</b> 9:00 AM - 5:00 PM
              </p>
              <p className="contactUs-paragraph">
                <b>{contactUs[language].address}:</b> Syria, Damascus, Pakistan Street
              </p>
            </div>

            <div className="contactUs-form">
              <h3>{contactUs[language].yourMessage}</h3>
              <form onSubmit={handleSubmit}>
                <div className="contactUs-formGroup">
                  <label htmlFor="name">{contactUs[language].name}</label>
                  <input
                    id="name"
                    type="text"
                    value={form.name}
                    onChange={handleChange}
                    placeholder={contactUs[language].enterName}
                    required
                    maxLength={100}
                  />
                </div>
                <div className="contactUs-formGroup">
                  <label htmlFor="email">{contactUs[language].email}</label>
                  <input
                    id="email"
                    type="email"
                    value={form.email}
                    onChange={handleChange}
                    placeholder={contactUs[language].enterEmail}
                    required
                    maxLength={100}
                  />
                </div>
                <div className="contactUs-formGroup">
                  <label htmlFor="message">{contactUs[language].message}</label>
                  <textarea
                    id="message"
                    rows="5"
                    value={form.message}
                    onChange={handleChange}
                    placeholder={contactUs[language].writeMessage}
                    required
                    maxLength={500}
                  ></textarea>
                </div>
                <button type="submit" className="contactUs-sendButton" disabled={loading}>
                  {loading
                    ? language === "ar" ? "يتم الإرسال..." : "Sending..."
                    : contactUs[language].sendMessage}
                </button>
              </form>
            </div>
          </div>

          <div className="contactUs-footer">
            <p>{contactUs[language].followLaftah}:</p>
            <div className="contactUs-socialIcons">
              <FontAwesomeIcon icon={faFacebook} />
              <FontAwesomeIcon icon={faInstagram} />
              <FontAwesomeIcon icon={faWhatsapp} />
            </div>
            <p>
              Copyright © 2025 Smart Software Services. All Rights Reserved |{" "}
              <Link to="/terms">{contactUs[language].terms}</Link> |{" "}
              <Link to="/privacy">{contactUs[language].privacyPolicy}</Link>
            </p>
          </div>
        </div>
      </motion.div>

      {/* Toast container for showing messages */}
      <ToastContainer position="top-center" autoClose={3000} rtl={language === "ar"} />
    </>
  );
}
